<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-select size="mini" v-model="formDatas.arfdFrom" clearable @change="partserch"
                        placeholder="请选择扣减渠道" style="width: 180px;">
                        <el-option label="系统" :value="1"></el-option>
                        <el-option label="易宝通" :value="2"></el-option>
                        <el-option label="河北小程序" :value="3"></el-option>
                    </el-select>
                    <el-input size="mini" v-model="formDatas.phone" clearable placeholder="请输入手机号"
                        style="width: 150px; margin-left: 10px;" @keyup.enter.native="partserch"></el-input>
                    <el-input size="mini" v-model="formDatas.uniqueNum" clearable placeholder="请输入唯一凭证"
                        style="width: 180px; margin-left: 10px;" @keyup.enter.native="partserch"></el-input>
                    <el-select size="mini" v-model="formDatas.arfdStatus" clearable @change="partserch"
                        placeholder="请选择状态" style="width: 130px; margin-left: 10px;">
                        <el-option label="成功" :value="1"></el-option>
                        <el-option label="失败" :value="2"></el-option>
                    </el-select>
                    <el-input size="mini" v-model="formDatas.specsSku" clearable placeholder="请输入商品编码"
                        style="width: 150px; margin-left: 10px;" @keyup.enter.native="partserch"></el-input>
                    <el-input size="mini" v-model="formDatas.resultDeduct" clearable placeholder="扣减信息模糊搜索"
                        style="width: 150px; margin-left: 10px;" @keyup.enter.native="partserch"></el-input>
                    <el-select size="mini" v-model="formDatas.arfdSyncEquityfee" clearable @change="partserch"
                        placeholder="是否同步" style="width: 130px; margin-left: 10px;">
                        <el-option label="否" :value="1"></el-option>
                        <el-option label="是" :value="2"></el-option>
                    </el-select>
                    <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss" v-loading="tableLoading" element-loading-background="rgba(255, 255, 255, 0.9)"
                element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading" custom-class="table-loading">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" style="width: 100%" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 回退弹框 -->
            <el-dialog title="系统操作回退(此功能会将权益金退回到用户账户,但不包括其他平台订单,请谨慎操作)" :visible.sync="dialogRollback" width="50%"
                :before-close="handleRollbackClose">
                <el-form :model="rollbackForm" label-width="100px">
                    <el-form-item label="回退原因">
                        <el-input type="textarea" v-model="rollbackForm.reason" placeholder="请输入回退原因"
                            :rows="4"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="handleRollbackClose">取 消</el-button>
                    <el-button type="primary" @click="confirmRollback">确 定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import {
    getAjefRightsFundDeductList, updateAjefRightsFundDeductRollback
} from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            dialogRollback: false,
            rollbackForm: {
                arfdId: null,
                reason: ''
            },
            currentRollbackRow: {},
            totalCount: 100,
            tableLoading: false,
            tableHight: 520,
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            columns: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "arfdFrom",
                    key: "arfdFrom",
                    title: "扣减渠道",
                    align: "center",
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return row.arfdFrom == 1 ? '系统' : row.arfdFrom == 2 ? '易宝通' : '河北小程序';
                    },
                },
                {
                    field: "uniqueNum",
                    key: "uniqueNum",
                    title: "唯一凭证",
                    align: "center",
                    width: 200,
                },
                {
                    field: "phone",
                    key: "phone",
                    title: "手机号",
                    align: "center",
                    width: 120,
                },
                {
                    field: "amount",
                    key: "amount",
                    title: "金额(分)",
                    align: "center",
                    width: 100,
                },
                {
                    field: "resultDeduct",
                    key: "resultDeduct",
                    title: "移动侧扣减信息",
                    align: "center",
                    width: 250,
                },
                {
                    field: "arfdStatus",
                    key: "arfdStatus",
                    title: "状态",
                    align: "center",
                    width: 80,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return row.arfdStatus == 1 ? <el-tag type="success">成功</el-tag> : <el-tag type="danger">失败</el-tag>;
                    },
                },
                { field: "specsSku", key: "specsSku", title: "商品编码", width: 150, align: "center" },
                { field: "specsName", key: "specsName", title: "商品名称", width: 150, align: "center" },
                {
                    field: "arfdSyncEquityfee",
                    key: "arfdSyncEquityfee",
                    title: "是否同步",
                    align: "center",
                    width: 90,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return row.arfdSyncEquityfee == 1 ? '否' : row.arfdSyncEquityfee == 2 ? '是' : '-';
                    },
                },
                { field: "createtime", key: "createtime", title: "创建时间", width: 160, align: "center" },
                { field: "createusername", key: "createusername", title: "创建人", width: 100, align: "center" },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 100,
                    align: "center",
                    fixed: "right",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"
                                    style="color: #E6A23C"
                                    on-click={() => {
                                        this.handleRollback(row);
                                    }}
                                >
                                    回退
                                </el-button>
                            </span>
                        );
                    },
                },
            ],
            tableData: [],
            formDatas: {
                currentPage: 1,
                pageSize: 10,
            },
        };
    },
    activated() {
        this.$nextTick(() => {
            this.tableHight = this.$store.state.windheight - 200 - this.$store.state.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                this.tableHight = val - 200 - val * 0.04;
            });
        },
    },
    deactivated() { },
    created() {
        this.tableHight = this.$store.state.windheight - 200 - this.$store.state.windheight * 0.04;
        this.getList();
    },
    mounted() { },
    methods: {
        handleRollback(row) {
            this.rollbackForm.arfdId = row.arfdId;
            this.rollbackForm.reason = '';
            this.currentRollbackRow = row;
            this.dialogRollback = true;
        },
        handleRollbackClose() {
            this.dialogRollback = false;
            this.rollbackForm = {
                arfdId: null,
                reason: ''
            };
            this.currentRollbackRow = {};
        },
        confirmRollback() {
            if (!this.rollbackForm.reason) {
                this.$message({
                    type: 'warning',
                    message: '请输入回退原因'
                });
                return;
            }
            const row = this.currentRollbackRow;
            const msg = `
                <div style="text-align: left; padding: 10px 0;">
                    <p><strong>手机号：</strong>${row.phone || '-'}</p>
                    <p><strong>金额：</strong>${row.amount || '-'}(分)</p>
                    <p><strong>唯一凭证：</strong>${row.uniqueNum || '-'}</p>
                    <p><strong>回退原因：</strong>${this.rollbackForm.reason}</p>
                </div>
            `;
            this.$confirm(msg, '确认回退操作', {
                confirmButtonText: '确定回退',
                cancelButtonText: '取消',
                type: 'warning',
                dangerouslyUseHTMLString: true
            }).then(() => {
                this.openLoading();
                updateAjefRightsFundDeductRollback(this.rollbackForm).then((res) => {
                    this.loadings.close();
                    if (res.data) {
                        this.$message({
                            type: 'success',
                            message: '操作成功'
                        });
                        this.handleRollbackClose();
                        this.getList();
                    }
                }).catch(() => {
                    this.loadings.close();
                });
            }).catch(() => { });
        },
        openLoading() {
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        pageSizeChange(pageSize) {
            this.formDatas.pageSize = pageSize;
            this.partserch();
        },
        pageNumberChange(pageIndex) {
            this.formDatas.currentPage = pageIndex;
            this.tableLoading = true;
            getAjefRightsFundDeductList(this.formDatas).then((res) => {
                this.tableLoading = false;
                this.tableData = res.data;
                this.totalCount = res.total;
            }).catch(() => {
                this.tableLoading = false;
            });
        },
        partserch() {
            this.formDatas.currentPage = 1;
            this.tableLoading = true;
            getAjefRightsFundDeductList(this.formDatas).then((res) => {
                this.tableLoading = false;
                this.tableData = res.data;
                this.totalCount = res.total;
            }).catch(() => {
                this.tableLoading = false;
            });
        },
        getList() {
            this.tableLoading = true;
            getAjefRightsFundDeductList(this.formDatas).then((res) => {
                this.tableLoading = false;
                this.tableData = res.data;
                this.totalCount = res.total;
            }).catch(() => {
                this.tableLoading = false;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>
